import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  beautifulObjectIds,
  defaultBeautifulObjectParams,
} from "@stellar-globe/stellar-globe"
import type {
  BeautifulObjectId,
  BeautifulObjectParams,
} from "@stellar-globe/stellar-globe"

type State = {
  params: Record<BeautifulObjectId, BeautifulObjectParams>
  dialogsOpen: Record<BeautifulObjectId, boolean>
}

function initialState(): State {
  return {
    params: Object.fromEntries(beautifulObjectIds.map(
      which => [which, defaultBeautifulObjectParams(which)],
    )) as State['params'],
    dialogsOpen: Object.fromEntries(beautifulObjectIds.map(
      which => [which, false],
    )) as State['dialogsOpen'],
  }
}

export const prettyPicturesSlice = createSlice({
  name: 'prettyPictures',
  initialState,
  reducers: {
    dialogToggled(state, { payload: { which, open } }: PayloadAction<{ which: BeautifulObjectId, open?: boolean }>) {
      state.dialogsOpen[which] = open ?? !state.dialogsOpen[which]
    },
    paramsUpdated(state, { payload: { which, params } }: PayloadAction<{ which: BeautifulObjectId, params: BeautifulObjectParams }>) {
      state.params[which] = params
    },
    paramsReset(state, { payload: which }: PayloadAction<BeautifulObjectId>) {
      state.params[which] = defaultBeautifulObjectParams(which)
    },
  },
})
